// @flow

import React from 'react'
import { containerIds } from 'modules/ui'
import SMConst from 'frontend_core/dist/constants/sm-const'
import CompanyQuestion from './CompanyQuestion'

// TODO 必要なpropsについて型チェックをする
type Props = {
  ui: {
    isChangedCompany: boolean,
  },
  company: {
    questions: {
      results: Array<{
        id: string,
        title: string,
        description: string,
        isRequired: boolean,
        isVisible: boolean,
        companyId: string,
        example: string,
      }>,
    },
  },
  onClickSave: Function,
}

export default class QuestionForm extends React.Component {
  constructor(props) {
    super(props)

    if (this.props.company.questions.results.length < 5) {
      const { actions, ui, company } = this.props
      const questions = company.questions.results
      const results = this.convertFormQuestions(questions)
      const questionState = {
        questions: { results },
      }
      actions.setQuestions(questionState)
    }
  }

  onClick = e => {
    e.preventDefault()
    const { actions } = this.props
    actions.setUIState(containerIds.BUSINESS_SETTING, {
      showSettingForm: true,
    })
  }

  convertFormQuestions = questions => {
    if (questions.length < 5) {
      const array = new Array(5 - questions.length).fill({
        title: '',
        description: '',
        example: '',
        isRequired: true,
        isVisible: false,
      })
      return [...questions, ...array]
    } else {
      return [...questions]
    }
  }

  onChangeInputText = (e, index) => {
    const { actions, ui, company } = this.props
    const input = e.target
    const results = [...company.questions.results]
    results[index] = { ...results[index], [input.name]: input.value }
    const questionState = {
      questions: { results },
    }
    actions.setQuestions(questionState)
  }

  onChangeRadio = (e, index, isVisible) => {
    const { actions, ui, company } = this.props
    const input = e.target
    const results = [...company.questions.results]
    results[index] = { ...results[index], isVisible: isVisible }
    const questionState = {
      questions: { results },
    }
    actions.setQuestions(questionState)
  }

  onChangeCheckbox = (e, index) => {
    const { actions, ui, company } = this.props
    const input = e.target
    const results = [...company.questions.results]
    results[index] = { ...results[index], isRequired: input.checked }
    const questionState = {
      questions: { results },
    }
    actions.setQuestions(questionState)
  }

  render() {
    const questions = this.props.company.questions.results

    return (
      <div>
        <ul style={{ overflow: 'auto' }}>
          <a href="" onClick={this.onClick}>
            <li className="business-employee__list-tab">
              {i18n.t('page.employee.l_00027')}
            </li>
          </a>
          <li className="business-employee__list-tab-current">
            {i18n.t('page.employee.l_00028')}
          </li>
        </ul>
        <div className="business-reservation-setting">
          <p className="business__supplement business__supplement-setting">
            最大5つまで予約リクエスト時に社員に入力させる質問事項を設定できます。
          </p>
          <div className="business-reservation-setting__item-wrap">
            {questions.map((question, index) => (
              <CompanyQuestion
                key={index}
                rowIndex={index}
                title={question.title || ''}
                description={question.description || ''}
                example={question.example || ''}
                isRequired={
                  question.isRequired === undefined ? true : question.isRequired
                }
                isVisible={
                  question.isVisible === undefined ? false : question.isVisible
                }
                onChange={this.onChangeInputText}
                onChangeRadio={this.onChangeRadio}
                onChangeCheckbox={this.onChangeCheckbox}
                ui={this.props.ui}
              />
            ))}
          </div>
        </div>
        <div className="ta-c">
          <input
            className="button-green maincol-buttonarea__button business-reservation-setting__button"
            type="button"
            value={'保存する'}
            onClick={this.props.onClickSave}
          />
        </div>
      </div>
    )
  }
}
